import sportsbanner from "../../../assets/CampuLifeImages/sportsbanner.png"
import sportsactivity1 from "../../../assets/CampuLifeImages/sportsactivity1.png"
import sportsactivity2 from "../../../assets/CampuLifeImages/sportsactivity2.jpg"
import sportsactivity3 from "../../../assets/CampuLifeImages/sportsactivity3.png"
import sportsactivity4 from "../../../assets/CampuLifeImages/sportsactivity4.jpg"

import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage'


const Sports = () => {

   const data =
  {
       name: "sports",
    hover: true,
    pagename: "Sports",
    title: "Sports Activities",
    contentImg: sportsbanner,
    paramission: "Sports Day Report On 2024-2025",
    paramissioncontent: "The sports day of our College for the academic year 2024-25 was held on 28th February, 2025 at 10a.m. Dr. K.A.Janardhanan, Pro Vice-Chancellor Administration and Dr.A Shajin Nargunam, Pro Vice-Chancellor Academic were the Chief Guests. The Principal Dr. R. Marimuthu presided over the function and Dr. Dhanya welcomed the gathering. Dr. K.A.Janardhanan, hoisted the National flag and Dr. A Shajin Nargunam hoisted the College sports flag.",
    para: "Sports play an important role in University institutions as it establishes a sense of community for college Students.",
    fourhover: true
  }

  const hoverContent = [
    { img: sportsactivity1, para1: "Students of all the houses, dressed in different coloured uniforms participated in the paraded wonderfully for the March past. The parade was led by the College NCC team.", para2: "February 28, 2025" },
    { img: sportsactivity2, para1: "The Olympic torch was carried by the College players and Mr.R S Abi, III IT, Sports Secretary of the College took the oath on behalf of every student.", para2: "February 28, 2025" },
    { img: sportsactivity3, para1: "The students performed pyramids, dances and aerobic exercises. Various games were conducted for the students. Blue house emerged as the house champion. Mr.R.Ashwin of II M.Com, won the individual championship for men and Miss R.J.Ashini I B.Sc(MB) for women", para2: "February 28, 2025" },
    { img: sportsactivity4, para1: "Shri.M.S.Faizal Khan, President, NICAS and JANAB Dr. A. P. Majeed Khan, Secretary, NICAS, distributed the prizes to the winners and encouraged the students. zThe meeting concluded with the vote of thanks by Mr.J.Jayaraj, Director of Physical Education, followed by National Anthem.", para2: "February 28, 2025" }
  ]



  const tableData = [
    { title: "Sports Committee Members" },
    { headings: [{ heading1: "S.No.", heading2: "Name", heading3: "Designation & Department", heading4: "Position", heading5: "Email ID" }] },
    {
      data: [
        { id: 1, name: 'Dr. R .Marimuthu', designDept: "Principal", pos: "Chairman", emailId: "nicollege2001@yahoo.co.in" },
        { id: 2, name: 'Mr. J. Jayaraj', designDept: "Physical Director", pos: "Convenor", emailId: "jayansheeja2011@gmil.com" },
        { id: 3, name: 'Mr. K. Krishna Prasad', designDept: "Asst. Prof., Department of  Computer Science (PG)", pos: "Member", emailId: "vskpnair@gmail.com" },
        { id: 4, name: 'Mr. Lt. V. I. Sree Dev', designDept: "Asst. Prof., Department of  English", pos: "Member", emailId: "sreedevambadiyil@gmail.com" },
        { id: 5, name: 'Mr. S. Sivakumar', designDept: "Asst. Prof., Department of  Business Management", pos: "Member", emailId: "stsiva2005@gmail.com" },
        { id: 6, name: 'Dr. C. Murugesan', designDept: "Asst. Prof., Department of  Mathematics (UG)", pos: "Member", emailId: "kumarithozhanmurugesan@gmail.com" },

      ]
    },
    { padding: true }
  ];
  return (

    <ExtenStudClubGrievPage data={data} hoverContent={hoverContent} tableData={tableData} />

  )
}

export default Sports